import { ROLE_LABELS } from '@crm/shared'
import type { AdminDashboardUserActivity } from '../types'
import { ModalShell } from './ModalShell'

function formatLastActive(iso: string | null): string {
  if (!iso) return 'нет активности'
  const date = new Date(iso)
  return date.toLocaleString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

function roleLabel(role: string): string {
  return ROLE_LABELS[role as keyof typeof ROLE_LABELS] ?? role
}

function UserRow({ user }: { user: AdminDashboardUserActivity }) {
  return (
    <div className="flex items-center justify-between gap-3 px-3 py-2">
      <div className="min-w-0">
        <div className="text-sm font-medium text-gray-900 truncate">{user.name}</div>
        <div className="text-xs text-gray-500 truncate">{user.email}</div>
      </div>
      <div className="text-right shrink-0">
        <div className="text-xs text-gray-700">{roleLabel(user.role)}</div>
        <div className={user.isOnline ? 'text-xs text-emerald-600' : 'text-xs text-gray-400'}>
          {user.isOnline ? 'сейчас онлайн' : `был активен: ${formatLastActive(user.lastActiveAt)}`}
        </div>
      </div>
    </div>
  )
}

export function UserActivityModal({
  users,
  onClose,
}: {
  users: AdminDashboardUserActivity[]
  onClose: () => void
}) {
  const online = users.filter((user) => user.isOnline)
  const offline = users.filter((user) => !user.isOnline)

  return (
    <ModalShell
      title="Активные пользователи"
      subtitle={`${online.length} онлайн · ${offline.length} неактивны`}
      onClose={onClose}
      size="md"
    >
      <div className="space-y-5">
        <section>
          <div className="text-xs text-gray-500 uppercase tracking-wide mb-2">Онлайн</div>
          <div className="divide-y divide-gray-100 rounded-xl border border-gray-100">
            {online.length > 0 ? (
              online.map((user) => <UserRow key={user.id} user={user} />)
            ) : (
              <div className="px-3 py-4 text-sm text-gray-400">Сейчас никого нет онлайн</div>
            )}
          </div>
        </section>

        <section>
          <div className="text-xs text-gray-500 uppercase tracking-wide mb-2">Неактивные</div>
          <div className="divide-y divide-gray-100 rounded-xl border border-gray-100">
            {offline.length > 0 ? (
              offline.map((user) => <UserRow key={user.id} user={user} />)
            ) : (
              <div className="px-3 py-4 text-sm text-gray-400">Неактивных пользователей нет</div>
            )}
          </div>
        </section>
      </div>
    </ModalShell>
  )
}
